const moods = [
        // {
        //     key: 'ALL', en: 'All', es: 'Todo',
        // },
        {
            key: 'ANXIOUS', en: 'Anxious', es: 'Ansioso',
        },
        {
            key: 'HAPPY', en: 'Happy', es: 'Feliz',
        },
        {
            key: 'RELAXED', en: 'Relaxed', es: 'Relajado',
        }, 
        {
            key: 'CAUTIOUS', en: 'Cautious', es: 'Cauteloso',
        }, 
        {
            key: 'CONCENTRATED', en: 'Concentrated', es: 'Concentrado',
        }, 
        {
            key: 'CONFIDENT', en: 'Confident', es: 'Seguro',
        }, 
        {
            key: 'EXCITED', en: 'Excited', es: 'Emocionado',
        }, 
        {
            key: 'OPTIMISTIC', en: 'Optimistic', es: 'Optimista',
        }, 
        {
            key: 'AGGRESSIVE', en: 'Aggressive', es: 'Agresivo',
        }, 
        {
            key: 'ANGRY', en: 'Angry', es: 'Enfadado',
        },
        {
            key: 'BORED', en: 'Bored', es: 'Aburrido',
        },
        {
            key: 'HURT', en: 'Hurt', es: 'Dolido',
        },
        {
            key: 'MAD', en: 'Mad', es: 'Furioso',
        },
        {
            key: 'NERVOUS', en: 'Nervous', es: 'Nervioso',
        },
        {
            key: 'SAD', en: 'Sad', es: 'Triste',
        },
        {
            key: 'UPSET', en: 'Upset', es: 'Molesto',
        },
        {
            key: 'SICK', en: 'Sick', es: 'Enfermo',
        },
        {
            key: 'NONE', en: 'None', es: 'Ninguno',
        }    
    ]

export default moods;